const dependencies = importAngularDependencies(
  require.context('./', true, /\.js/),
  './patient.common.js'
);

export default angular.module('doxy.patient.common', dependencies).name;
